import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { formValidation } from '../../../utils/functions'
import Button from '../../button'
import FormFileInput from '../../form-file-input'
import CloseSVG from '../../../assets/svg/close.svg'
import { useRunBasicPayrollExcel } from '../../../redux/payroll/hook'
import FormInput from '../../form-input'
import DOMPurify from 'dompurify'
import FormSelect from '../../form-select'
import { useHistory } from 'react-router-dom'
import Modal from '../modal'
import moment from 'moment'
import { useExportSalaryTemplate } from '../../../redux/employees/hook'
import { employees as employeeAPI } from '../../../api/employees'
import Excel from 'exceljs'
import { saveAs } from 'file-saver'
import AsyncSelect from 'react-select/async'
import {
  useGetEmployeeGroups,
  useGetGroupEmployees,
} from '../../../redux/employees/hook/groups'
import { PAGINATION_DEFAULT } from '../../../utils/constants'
import ButtonSelect from '../../button-select'
import { useSelector } from 'react-redux'

function RunBulkBasicPayroll({ isOpen, closeModal, refresh }) {
  const { mutateAsync, isLoading } = useRunBasicPayrollExcel()
  const {
    register,
    handleSubmit,
    errors,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  })

  const { company } = useSelector((state) => state.companySlice)

  const basePayrollFee = company?.fee_charges?.basic_payroll || 400
  const payslipFee = basePayrollFee + 100
  const history = useHistory()

  const [validate, setValidation] = useState(1)
  const [exportType, setexportType] = useState('all')
  const [selectedGroup, setSelectedGroup] = useState(null)

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const { data: employeeGroups } = useGetEmployeeGroups(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )
  const [option, setOption] = useState(1)

  // const { data: groupEmployees } = useGetGroupEmployees(
  //   id,
  //   pagination?.limit,
  //   pagination?.page,
  //   pagination?.statusFilter,
  //   pagination?.search
  // )
  // const {groupType, setGroupType}

  const [employees, setEmployees] = useState([])

  const typeOptions = [
    {
      value: 'all',
      label: 'All employees',
    },
    {
      value: 'select',
      label: 'Selected Employees',
    },
    // {
    //   value: 'group',
    //   label: 'Select Payroll group',
    // },
  ]

  const employeeGroupOptions =
    employeeGroups?.data?.map((group) => ({
      value: group?.name,
      label: group?.name,
    })) || []

  const loadPayrollGroupOptions = (inputValue) => {
    return new Promise((resolve) => {
      if (employeeGroups && employeeGroups.data) {
        const payrollGroups = employeeGroups.data.map((group) => ({
          label: `${group.name} | ${group.group_payroll_country}`,
          value: group.id,
        }))

        const filteredOptions = payrollGroups.filter((group) =>
          group.label.toLowerCase().includes(inputValue.toLowerCase())
        )

        resolve(filteredOptions)
      } else {
        resolve([])
      }
    })
  }

  const loadOptions = (inputValue) =>
    new Promise((resolve) => {
      employeeAPI
        .getEmployees({
          limit: 10,
          statusFilter: -1,
          search: inputValue,
          page: 1,
        })
        .then((response) => {
          let data = []
          response.data.forEach((item) => {
            data.push({
              label: `${item.first_name} ${item.last_name} | ${item.mobile} | ${item.email}`,
              value: item.id,
            })
          })

          resolve(data)
        })
        .catch((err) => {
          resolve([])
        })
    })

  const validationOptions = [
    { label: 'Yes (Takes Longer)', value: 1 },
    { label: 'No (Faster)', value: 0 },
  ]

  const workbook = new Excel.Workbook()

  const columns = [
    { header: "Employee's First Name", key: 'first_name' },
    { header: "Employee's Last Name", key: 'last_name' },
    { header: 'Phone Number', key: 'mobile' },
    { header: 'Amount (Number Only, No Commas)', key: 'amount' },
    { header: 'Status', key: 'status' },
  ]

  const { mutateAsync: exportSalaryTemplate } = useExportSalaryTemplate()
  const [exportLoading, setSetExportLoading] = useState(false)

  const exportTemplate = async () => {
    setSetExportLoading(true)
    await exportSalaryTemplate().then(async (response) => {
      // Export only active employees
      let data = response?.data?.filter((item) => item.status === 1)
      const workSheetName = 'active_employee_data'
      const workBookName = `Employee payment upload data (pre-filled)`
      try {
        const fileName = workBookName

        const worksheet = workbook.addWorksheet(workSheetName)

        // add worksheet columns
        // each columns contains header and its mapping key from data
        worksheet.columns = columns

        // updated the font for first row.
        worksheet.getRow(1).font = { bold: true }

        // loop through all of the columns and set the alignment with width.
        worksheet.columns.forEach((column) => {
          if (column._number == 4) {
            column.width = 18
            column.style.alignment = { horizontal: 'right' }
            column.numFmt = '0.00'
          } else if (column._number > 5) {
            column.numFmt = 'YYYY-MM'
          } else {
            column.width = column.header.length + 2
            column.style.alignment = { horizontal: 'left' }
          }
        })
        if (exportType == 'all') {
          data?.forEach((singleData) => {
            singleData.month = ''
            singleData.description = ''
            singleData.amount = ''
            if (singleData.status == 0) {
              singleData.status = 'Inactive'
            } else if (singleData.status == 1) {
              singleData.status = 'Active'
            } else if (singleData.status == 2) {
              singleData.status = 'Pending'
            } else if (singleData.status == 3) {
              singleData.status = 'Deleted'
            } else if (singleData.status == 2) {
              singleData.status = 'Awaiting Activation'
            } else {
              singleData.status = 'Pre-registered'
            }
            worksheet.addRow(singleData)
          })
        } else if (exportType == 'select' && employees.length > 0) {
          employees.forEach((employee) => {
            data?.forEach((singleData) => {
              if (employee.value == singleData.id) {
                singleData.month = ''
                singleData.description = ''
                singleData.amount = ''
                if (singleData.status == 0) {
                  singleData.status = 'Inactive'
                } else if (singleData.status == 1) {
                  singleData.status = 'Active'
                } else if (singleData.status == 2) {
                  singleData.status = 'Pending'
                } else if (singleData.status == 3) {
                  singleData.status = 'Deleted'
                } else if (singleData.status == 2) {
                  singleData.status = 'Awaiting Activation'
                } else {
                  singleData.status = 'Pre-registered'
                }
                worksheet.addRow(singleData)
              }
            })
          })
        }

        // loop through all of the rows and set the outline style.
        worksheet.eachRow({ includeEmpty: true }, (row) => {
          // store each cell to currentCell
          const currentCell = row._cells

          // loop through currentCell to apply border only for the non-empty cell of excel
          currentCell.forEach((singleCell) => {
            // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
            const cellAddress = singleCell._address
            // if (singleCell._column._number == 8) {

            // }
            if (
              singleCell._column._number == 8 &&
              singleCell._row._number > 1
            ) {
              if (singleCell._value.model.value == 'Inactive') {
                worksheet.getCell(cellAddress).font = {
                  color: { argb: 'D34829' },
                }
              } else if (singleCell._value.model.value == 'Active') {
                worksheet.getCell(cellAddress).font = {
                  color: { argb: '0d5225' },
                }
              } else if (singleCell._value.model.value == 'Pending') {
                worksheet.getCell(cellAddress).font = {
                  color: { argb: 'FFA500' },
                }
              } else if (singleCell._value.model.value == 'Deleted') {
                worksheet.getCell(cellAddress).font = {
                  color: { argb: 'D34829' },
                }
              } else if (
                singleCell._value.model.value == 'Awaiting Activation'
              ) {
                worksheet.getCell(cellAddress).font = {
                  color: { argb: 'FFA500' },
                }
              } else {
                worksheet.getCell(cellAddress).font = {
                  color: { argb: 'FFA500' },
                }
              }
            }
            worksheet.getCell(cellAddress).border = {
              top: { style: 'none' },
              left: { style: 'none' },
              bottom: { style: 'none' },
              right: { style: 'none' },
            }
          })
        })

        // write the content using writeBuffer
        const buf = await workbook.xlsx.writeBuffer()

        // download the processed file
        saveAs(new Blob([buf]), `${fileName}.xlsx`)
      } catch (error) {
        // console.error('<<<ERRROR>>>', error);
        // console.error('Something Went Wrong', error.message);
      } finally {
        workbook.removeWorksheet(workSheetName)
      }
    })
    setSetExportLoading(false)
  }

  async function submitForm(data) {
    const month = DOMPurify.sanitize(data?.month)
    const desc = DOMPurify.sanitize(data?.desc)
    const formData = new FormData()

    formData.append('file', data?.file[0])
    formData.append('month', month)
    formData.append('desc', desc)
    formData.append('validate', validate)
    formData.append('payslip', option)

    await mutateAsync(formData).then((result) => {
      closeModal()
      // if (result.status === 'success') {
      //   history.push(`/payroll/basic/preview/${result.data.payroll.ref}`)
      // }
    })
  }

  return (
    <Modal
      scrollable={true}
      className='!max-w-[700px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto pb-4'>
        <form onSubmit={handleSubmit(submitForm)}>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-3'>Make Employee Payment</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col px-8'>
            <div className='flex flex-col gap-3'>
              <FormSelect
                value={exportType}
                options={typeOptions}
                onChange={(selected) => {
                  setexportType(selected)
                }}
                label='Select Template Export Type'
                extraClass={'bg-white'}
              />
              {/* {exportType === 'group' && (
                <FormSelect
                  value={selectedGroup}
                  options={employeeGroupOptions}
                  onChange={(selected) => {
                    setSelectedGroup(selected)
                  }}
                  label='Select Payroll Group'
                  extraClass={'bg-white mb-4'}
                />
              )} */}
            </div>

            <div>
              {/* {selectedGroup && (
                <>
                  <div>
                    <label className='!text-[13px] leading-[23px] font-normal text-color-gray mb-1'>
                      Select Employees
                    </label>
                    <AsyncSelect
                      // isMulti
                      cacheOptions
                      defaultOptions
                      className='text-[13px]'
                      placeholder={'Type to select multiple employees'}
                      loadOptions={loadOptions}
                      onChange={(options) => setEmployees(options)}
                      classNamePrefix='mySelect'
                    />
                  </div>
                </>
              )} */}
              {exportType === 'select' ? (
                <div>
                  <label className='!text-[13px] leading-[23px] font-normal text-color-gray mb-1'>
                    Select Employees
                  </label>
                  <AsyncSelect
                    isMulti
                    cacheOptions
                    defaultOptions
                    className='text-[13px]'
                    placeholder={'Type to select multiple employees'}
                    loadOptions={loadOptions}
                    onChange={(options) => setEmployees(options)}
                    classNamePrefix='mySelect'
                  />
                </div>
              ) : null}
            </div>
            {exportType == 'all' || employees.length > 0 ? (
              <>
                <div className='flex flex-col text-center mb-3 justify-center items-center'>
                  <span className='header-5-medium'>
                    Upload employees Payment details from XLSX file
                  </span>
                  <div className=' flex flex-col border p-2 rounded-md bg-highlight mt-2 mb-1 justify-center items-center w-full'>
                    <Button
                      text='Download template'
                      type='button'
                      theme='primary'
                      loading={exportLoading}
                      className='flex gap-2 !h-[35px] w-[220px] p-2 '
                      textClass={'!text-[11px]'}
                      onClick={() => {
                        exportTemplate()
                      }}
                    />
                  </div>
                  <FormFileInput
                    multiSource={true}
                    inputRef={register(formValidation('file', true))}
                    accept='.xlsx'
                  />
                </div>
                <hr className='divider' />
                <FormInput
                  label='Description'
                  name='desc'
                  type='text'
                  inputRef={register(formValidation('text', true))}
                  readOnly={isLoading}
                  error={errors.desc}
                  errorMessage={errors.desc && errors.desc.message}
                />

                <div className='flex flex-row md:flex-col w-full justify-between'>
                  <div className='w-full'>
                    <FormInput
                      label='Select Payment Date'
                      name='month'
                      type='date'
                      defaultValue={moment().format('YYYY-MM-DD')}
                      inputRef={register(formValidation('text', true))}
                      error={errors.month}
                      errorMessage={errors.month && errors.month.message}
                    />
                  </div>
                  {/* <div className='w-full md:w-1/2 pl-2'>
                    <FormSelect
                      value={validate}
                      options={validationOptions}
                      onChange={(selected) => {
                        setValidation(selected)
                      }}
                      label='Validate Bank Accounts'
                    />
                  </div> */}
                </div>
                <ButtonSelect
                  title={`I want to download and send payslips to my employee. ₦${payslipFee} per employee`}
                  subtitle={''}
                  isActive={option === 1}
                  onClick={() => setOption(1)}
                />

                <ButtonSelect
                  title={`I don't want to download and send payslips to my employee. ₦${basePayrollFee} per employee`}
                  subtitle={''}
                  isActive={option === 0}
                  onClick={() => setOption(0)}
                  className='mt-4'
                />
                <div className='w-full mt-[30px]'>
                  <Button text='RUN' type='submit' loading={isLoading} />
                </div>
              </>
            ) : (
              <div className='flex flex-col border bg-highlight p-2 rounded-md items-center justify-center text-[14px]'>
                Select at least one employee to download template
              </div>
            )}
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default RunBulkBasicPayroll
